import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
//import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBejH064ylbuErnoXMLe_oavppZ6jblemM',
  authDomain: 'monkeybox-9c477.firebaseapp.com',
  databaseURL: 'https://monkeybox-9c477-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'monkeybox-9c477',
  storageBucket: 'monkeybox-9c477.firebasestorage.app',
  messagingSenderId: '922281044984',
  appId: '1:922281044984:web:00367b88981dc02004040d',
  measurementId: 'G-84T6DJZ9VF',
};

const app = initializeApp(firebaseConfig);
export const rtdb = getDatabase(app);
